module.exports = __webpack_public_path__ + "img-dashboard/register/icon-service-circle-white.bf0b1261.png";